import { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useRoutes } from 'hookrouter';
import Routes from '../routes/routes';
import {
  CircularProgress,
  Dialog,
  DialogContent,
  MenuItem,
  Paper,
  Typography,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import {
  getExisitingTemplates,
  getSpecificTemplates,
  setUploadSelector,
  getSelectedTemplateSelector,
  resetUploadStates,
  setAllInstancesSelector,
  createInstanceMultiple,
  truncateAndCreateInstanceMultiple,
} from '../../services/uploadSlice';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import { setTypeSelector, resetTemplateStates } from '../../services/templateSlice';
import NavBar from '../NavBar/navbar';
import { navigate } from 'hookrouter';
import { headersAreMatching, parseUploadedExcelSheetToJson } from '../../utils/fileUtil';
const Swal = require('sweetalert2');

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: theme.spacing(1),
      textAlign: 'left',
    },
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  pos: {
    marginBottom: 12,
  },
  textfield: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  gridpaper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  fieldpos: {
    fontSize: '20px',
  },
  paper: {
    padding: theme.spacing(1),
  },
  dialogBox: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  header: {
    margin: theme.spacing(2),
    textAlign: 'center',
  },
  btn: {
    margin: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(3),
    textAlign: 'left',
    '& .MuiFormControl-root': {
      width: '100%',
      textAlign: 'left',
      padding: '0',
    },
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  wrap: {
    margin: theme.spacing(4),
    textAlign: 'center',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function UploadData() {
  useRoutes(Routes);

  if (localStorage.getItem('auth') !== 'true') {
    navigate('/', true);
  }

  const classes = useStyles();
  const dispatch = useDispatch();
  const [message, setmessage] = useState('Searching for templates');
  const [isData, setisData] = useState(false);
  const uploadResponse = useSelector(setUploadSelector);
  const specificTemplateResponse = useSelector(getSelectedTemplateSelector);
  const typesResponse = useSelector(setTypeSelector);
  const [defaultTemplate, setdefaultTemplate] = useState('');
  const allInstanceResponse = useSelector(setAllInstancesSelector);
  const [templates, setTemplates] = useState([]);
  const [datatypes, setdatatypes] = useState([]);
  const [modifiedTemplateID, setmodifiedTemplateID] = useState('');
  const [customerID, setcustomerID] = useState(parseInt(localStorage.getItem('userId')));
  const [dataTypeMap, setdataTypeMap] = useState({});
  const [dataTypeFieldMapping, setdataTypeFieldMapping] = useState({});
  const [existingtempFields, setexistingtempFields] = useState([]);
  const [dispatched, setDispatched] = useState(false);
  const [open, setOpen] = useState(false);
  const [uploadedFileName, setuploadedFileName] = useState('');
  const [shouldTruncate, setShouldTruncate] = useState(false);

  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [progress, setprogress] = useState(0);
  const [hasvalidTemplate, sethasvalidTemplate] = useState(false);
  const [templateLoader, settemplateLoader] = useState(true);

  if (!dispatched) {
    setmessage('Searching for templates');
    settemplateLoader(true);
    dispatch(getExisitingTemplates(customerID));
    setDispatched(true);
  }

  useEffect(() => {
    window.onpopstate = () => {
      setdefaultTemplate('');
      sethasvalidTemplate(false);
      dispatch(resetUploadStates());
      dispatch(resetTemplateStates());
      setTemplates([]);
    };
  });

  useEffect(() => {
    if (templates.length !== 0) {
      settemplateLoader(false);
    }
  }, [templates]);

  useEffect(() => {
    if (defaultTemplate !== '') {
      sethasvalidTemplate(true);
    } else {
      setmessage('No templates found');
      sethasvalidTemplate(false);
    }
  }, [defaultTemplate]);

  useEffect(() => {
    setdefaultTemplate('');
    sethasvalidTemplate(false);
    settemplateLoader(true);
    setmessage('Searching for templates');
    var activeTemplates = [];
    if (uploadResponse === null) {
      setmessage('');
      setexistingtempFields([]);
      settemplateLoader(false);
      setisData(false);
      dispatch(resetUploadStates());
    } else if (uploadResponse.length != 0) {
      for (var response of uploadResponse) {
        if (!response?.template?.isDisabled) {
          activeTemplates.push(response.template);
        }
      }
      setTemplates(activeTemplates);
      setisData(true);
      setdefaultTemplate(activeTemplates[0].id);
      fetchDetailsforModification(activeTemplates[0].id);
    } else if (uploadResponse.length === 0) {
      setmessage('');
      setexistingtempFields([]);
      settemplateLoader(false);
      setisData(false);
      dispatch(resetUploadStates());
    }
  }, [uploadResponse]);

  const fetchDetailsforModification = (modifiedTemplateID) => {
    setmodifiedTemplateID(modifiedTemplateID);
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    dispatch(getSpecificTemplates(modifiedTemplateID));
  };

  useEffect(() => {
    setTemplates([]);
  }, []);

  const getTemplateFields = (templateResponse) => {
    return templateResponse?.map((i) => {
      return {
        id: uuidv4(),
        question: i.name,
        type: i.type.id,
        isMany: i.isMany,
        isSearchable: i.isSearchable,
        value: '',
        attributeid: i.id,
      };
    });
  };

  useEffect(() => {
    if (specificTemplateResponse?.length != 0) {
      setexistingtempFields(getTemplateFields(specificTemplateResponse));
    }
  }, [specificTemplateResponse]);

  const processData = (parsedJsonDataList) => {
    if (parsedJsonDataList?.length > 0) {
      parsedJsonDataList.forEach((eachData) => {});
      const excelHeaders = Object.keys(parsedJsonDataList[0]).sort();
      const existingTemplateHeaders = existingtempFields.map((ele) => ele.question).sort();
      if (headersAreMatching(excelHeaders, existingTemplateHeaders)) {
        dispatch(
          getSpecificTemplates(modifiedTemplateID, (specificTemplateResponse) => {
            if (specificTemplateResponse?.length != 0) {
              setexistingtempFields(getTemplateFields(specificTemplateResponse));
              var data = {};
              var payload = [];
              const selectedTemplateHeaders = specificTemplateResponse.reduce((acc, ele) => {
                acc[ele.name] = ele.id;
                return acc;
              }, {});
              parsedJsonDataList?.forEach((eachData) => {
                let temp = [];
                if (eachData && Object.keys(eachData)?.length > 0) {
                  Object.keys(eachData).forEach((key) => {
                    if (Object.keys(selectedTemplateHeaders).includes(key))
                      temp.push({
                        templateAttribute: selectedTemplateHeaders[key],
                        content: eachData[key],
                      });
                  });
                }
                payload.push(temp);
              });

              data = {
                payload: payload,
                username: localStorage.getItem('username'),
                templateId: modifiedTemplateID,
                filename: escape(uploadedFileName),
              };
              if (!shouldTruncate) dispatch(createInstanceMultiple(data));
              else dispatch(truncateAndCreateInstanceMultiple(data));
            }
          }),
        );
      } else {
        setLoading(false);
        Swal.fire({
          text: 'The uploaded file headers does not match with the existing template',
          icon: 'error',
        }).then((result) => {});
      }
    }
  };

  const handleFileUpload = (e) => {
    setLoading(true);
    const file = e.target.files[0];
    if (file !== '') {
      setuploadedFileName(file.name);
    }
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const workbook = XLSX.read(bstr, {
        type: 'binary',
        raw: true, // Keep raw values to avoid date conversion
        cellDates: true,
      });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = parseUploadedExcelSheetToJson(worksheet);
      processData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  useEffect(() => {
    axios
      .get('/api/type/')
      .then((response) => {
        var jsonResponse = response.data;
        if (datatypes.length === 0) setdatatypes(jsonResponse);
      })
      .catch((error) => {
        console.log('Fetch data types error');
      });

    updateTemplates();
  }, [datatypes]);

  const updateTemplates = () => {
    let types = {};
    let fieldMap = {};

    datatypes.map((type) => (types[type.id] = type.name));

    for (const [key, value] of Object.entries(types)) {
      if (value === 'Number') {
        fieldMap[value] = 'number';
      } else if (value === 'True/False') {
        fieldMap[value] = 'text';
      } else if (value === 'Text') {
        fieldMap[value] = 'text';
      }
    }

    setdataTypeMap(types);
    setdataTypeFieldMapping(fieldMap);
  };

  useEffect(() => {
    if (allInstanceResponse.length !== 0) {
      handleClose();
      setLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Link Search Template submission',
        text: 'Upload initiated successfully',
      }).then((result) => {
        dispatch(resetUploadStates());
        dispatch(resetTemplateStates());
        setIndex(0);
        setuploadedFileName('');
        navigate('/uploads/' + modifiedTemplateID);
        setmodifiedTemplateID('');
      });
    } else if (allInstanceResponse.length === 0 && loading) {
      handleClose();
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Search Template submission',
        text: 'Could not upload data',
      }).then((result) => {
        dispatch(resetUploadStates());
        dispatch(resetTemplateStates());
        setIndex(0);
        setuploadedFileName('');
      });
    }
  }, [allInstanceResponse]);

  const handleAddFieldsForExisting = (inputField) => {
    setexistingtempFields([
      ...existingtempFields,
      {
        id: uuidv4(),
        question: inputField.question,
        type: inputField.type,
        isMany: inputField.isMany,
        isSearchable: inputField.isSearchable,
        value: inputField.value,
        attributeid: inputField.attributeid,
      },
    ]);
  };

  const handleRemoveFieldsForExisting = (id) => {
    const values = [...existingtempFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setexistingtempFields(values);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (typesResponse.length !== 0) {
      setdatatypes(typesResponse);
    }
  }, [typesResponse]);

  const hiddenFileInput = useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleSelectTemplate = (id) => {
    fetchDetailsforModification(id);
  };

  return (
    <>
      <NavBar />
      <div>
        {isData === false && templateLoader === false && (
          <Typography variant="h5" className={classes.header}>
            {message}
          </Typography>
        )}

        {isData && (
          <>
            {progress === 0 && (
              <Typography variant="h5" className={classes.header}>
                Template Entities
              </Typography>
            )}
            <Paper className={classes.wrap} elevation={6}>
              {!loading && !templateLoader ? (
                <div>
                  <Grid container spacing={6} className={classes.root}>
                    {templateLoader === false && (
                      <Grid item md={3} sm={12} xs={12}>
                        {templateLoader === false && (
                          <TextField
                            select
                            defaultValue={templateLoader === false ? defaultTemplate : ''}
                            name="question"
                            label="Choose Template"
                            variant="outlined"
                            onChange={(e) => handleSelectTemplate(e.target.value)}
                          >
                            {templates.map((template) => (
                              <MenuItem value={template.id}>
                                {template.name} - {template.version}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      </Grid>
                    )}
                    <Button
                      variant="outlined"
                      startIcon={<AttachFileIcon />}
                      className={classes.btn}
                      color="default"
                      onClick={handleClick}
                    >
                      Upload data via file
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={<AttachFileIcon />}
                      className={classes.btn}
                      color="default"
                      onClick={(e) => {
                        setShouldTruncate(true);
                        handleClick(e);
                      }}
                    >
                      Truncate and Upload data via file
                    </Button>
                  </Grid>
                  <input
                    type="file"
                    accept=".csv,.xlsx,.xls"
                    onChange={handleFileUpload}
                    ref={hiddenFileInput}
                    style={{ display: 'none' }}
                  />
                  <form className={classes.root}>
                    {existingtempFields &&
                      existingtempFields.map((inputField) => (
                        <div key={inputField.id}>
                          <Grid container spacing={6}>
                            <Grid item md={2} sm={12} xs={12}>
                              <Typography style={{ marginTop: '13px' }}>
                                {inputField.question}
                              </Typography>
                            </Grid>
                            <Grid item md={2} sm={12} xs={12}>
                              <Typography style={{ marginTop: '13px' }}>
                                {dataTypeMap[inputField.type]}
                              </Typography>
                            </Grid>
                            {inputField.isMany && false && (
                              <Grid item md={1} sm={12} xs={12}>
                                <IconButton
                                  onClick={() => handleRemoveFieldsForExisting(inputField.id)}
                                >
                                  <RemoveIcon />
                                </IconButton>
                              </Grid>
                            )}
                            {inputField.isMany && false && (
                              <Grid item md={1} sm={12} xs={12}>
                                <IconButton onClick={() => handleAddFieldsForExisting(inputField)}>
                                  <AddIcon />
                                </IconButton>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                      ))}
                  </form>
                </div>
              ) : (
                <Dialog open={loading}>
                  <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
                    <CircularProgress />
                    <Typography variant="h6">Uploading data</Typography>
                  </DialogContent>
                </Dialog>
              )}
            </Paper>
          </>
        )}
        <Dialog open={templateLoader}>
          <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
            <CircularProgress />
            <Typography variant="h6">Fetching Latest Details</Typography>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
